import { Icon } from "@iconify/react";

import InstagramIcon from "@/icons/instagram.svg?react";
import WhatsappIcon from "@/icons/whatsapp.svg?react";

import { CHANNEL_TYPE, ChannelType } from "@/types/channel";

interface ChannelIconProps extends React.SVGProps<SVGSVGElement> {
  type: ChannelType;
  size?: number;
}

export const ChannelIcon = ({
  type,
  size = 20,
  ...props
}: ChannelIconProps) => {
  switch (type) {
    case CHANNEL_TYPE.INSTAGRAM:
      return <InstagramIcon height={size} width={size} {...props} />;
    case CHANNEL_TYPE.WHATSAPP:
      return <WhatsappIcon height={size} width={size} {...props} />;
    case CHANNEL_TYPE.MESSENGER:
      return <Icon height={size} icon="logos:messenger" width={size} />;
    case CHANNEL_TYPE.TIKTOK:
      // Use Iconify until official SVG is added
      return <Icon height={size} icon="ic:baseline-tiktok" width={size} />;
    case CHANNEL_TYPE.PHONE:
      return <Icon height={size} icon="solar:phone-bold" width={size} />;
    default:
      return <Icon height={size} icon="solar:channel-linear" width={size} />;
  }
};
